import { useEffect, useState } from 'react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { screenSize } from 'lib/utils';
import arrowIcon from '../../../assets/images/about-us/red-block-arrow.png';

/**
 * @param {Object} props
 * @param {Array<Object>} items - a list of slider items with a name and image url
 * @returns slider populated with given images
 */
const AboutUsSlider = ({ items }) => {
  const [isMobile, setIsMobile] = useState(screenSize() < 1025);
  const itemsPerPage = isMobile ? 1 : 4;
  const [current, setCurrent] = useState(1);
  const totalSlides = 4;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(screenSize() < 1025);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="about-us__stats-splide v2-container fl fl-col l-fl-row jc-sb ai-c width-100">
      <Splide
        hasTrack={false}
        options={{
          perPage: itemsPerPage,
          pagination: false,
          gap: isMobile ? '1rem' : '0',
          perMove: 1,
          arrows: items.length > itemsPerPage,
          autoWidth: true,
        }}
        onMove={(splide, newIndex) => {
          setCurrent(newIndex + 1);
        }}
        onMounted={splide => {
          setCurrent(splide.index + 1);
        }}>
        <SplideTrack>
          {items.map(
            ({
              src,
              stat_number: statNumber,
              stat_number_text: statNumberText,
              stat_text: statText,
              legal,
            }) => (
              <SplideSlide
                className="about-us__stat-splide"
                key={statNumberText.toLowerCase().replace(/\s/g, '')}
                data-testid="splide__slide--about-us-stat"
                tabIndex="0">
                <div className="about-us__stat fl fl-col jc-fe mtb-12">
                  <img
                    src={src}
                    width={280}
                    height={280}
                    alt=""
                    className="about-us__stat-background"
                  />
                  <div className="about-us__stat-content">
                    <h2 className="fw-800 fs-50 mb-10">{statNumber}</h2>
                    <p className="stat-content__number-text fw-700">
                      {statNumberText}
                    </p>
                    <p className="stat-content__text">
                      {statText}
                      <span className="stat-content__text-legal fs-11">
                        {legal}
                      </span>
                    </p>
                  </div>
                </div>
              </SplideSlide>
            ),
          )}
        </SplideTrack>

        <div className="splide__arrows">
          <p className="m-0 p-0 mr-8 fs-18 fw-700">
            {current}/{totalSlides}
          </p>
          <button className="splide__arrow splide__arrow--prev" type="button">
            <img src={arrowIcon} width={48} height={48} alt="" />
          </button>
          <button className="splide__arrow splide__arrow--next" type="button">
            <img src={arrowIcon} width={48} height={48} alt="" />
          </button>
        </div>
      </Splide>
    </div>
  );
};
export default AboutUsSlider;
